/* Accessory PDP (sections/reformly-acc-hero.liquid).
   Copy of reformly-sp.js, `rsp` namespace renamed `rac`.

   State is three values: the chosen pack quantity, whether the membership is
   on, and which gallery shot is showing. Everything on screen derives from
   them, so the pack cards and the form quantity cannot disagree.

   THE PRICES HERE ARE A PREDICTION. Shopify charges; this page only displays
   what the configured packs say it should. If the automatic discounts in admin
   do not match `section.settings.packs`, the buyer sees one number here and
   another at checkout. The section documents the same warning. */
(function () {
  'use strict';

  function init(root) {
    /* Once per element. `shopify theme dev` re-runs page scripts on hot reload
       and the theme editor re-renders sections, so boot() can fire repeatedly —
       which was stacking FOUR Swiper instances on the spotlight (four
       `swiper-notification` nodes in the DOM) and would have double-bound the
       add-to-cart click too. */
    if (root.dataset.racReady) return;
    root.dataset.racReady = '1';

    var BASE = parseInt(root.dataset.base, 10) || 0;
    var MEMBER_PCT = parseFloat(root.dataset.memberPct) || 0;
    var PACKS = [];
    try { PACKS = JSON.parse(root.dataset.packs) || []; } catch (e) {}

    /* NO EARLY RETURN ON AN EMPTY PACK LIST. This used to be
       `if (!PACKS.length || !BASE) return;`, which was fine while every
       template using this file had socks' quantity packs — and fatal the
       moment the accessory template emptied `packs` for the bundle builder.
       It killed the WHOLE section: the gallery Swiper, the thumb strip, the
       zoom and the review spotlight all live below this line, so the symptom
       was "the arrows don't work" and "the swatches don't change the image"
       rather than anything about packs.

       The pack code below is guarded individually instead. */
    var hasPacks = PACKS.length > 0 && BASE > 0;

    var fmt = root.dataset.moneyFormat || '${{amount}}';

    /* ---------- money ----------
       Prices arrive from Liquid in CENTS and are only divided at the point of
       display — doing the arithmetic in cents avoids the drift that shows up as
       a total one cent off the sum of its lines. */
    function money(cents) {
      return formatMoney(cents, fmt);
    }

    /* ---------- Shopify's own money arithmetic ----------
       Verified against a real cart on the sock bundle builder:

         original_price   2200
         final_price      1446   = 2200 - floor(2200 * 0.343)
         final_line       5784   = 1446 * 4

       Shopify FLOORS the per-unit discount to whole cents and multiplies by
       quantity. It does not discount the line and divide, and it does not
       round. Getting this wrong is not cosmetic: rounding the line quoted
       $57.82 against a checkout of $57.84. */
    function unitCents(wasCents, pct) {
      return wasCents - Math.floor(wasCents * pct / 100);
    }

    /* The export composes the two discounts multiplicatively:

         unit = base * (1 - pct/100) * (gold ? 0.9 : 1)

       so 27% with the membership is NOT 37% — it is 34.3%, which is exactly the
       rate the "Sock Bundle + Member" discounts carry in admin. Composing them
       any other way would quote a total Shopify will not charge. */
    function effectivePct(packPct) {
      if (!member) return packPct;
      var keep = (1 - packPct / 100) * (1 - MEMBER_PCT / 100);
      return (1 - keep) * 100;
    }

    /* ---------- state ---------- */
    var packEls = [].slice.call(root.querySelectorAll('[data-rac-pack]'));
    var qtyEl = root.querySelector('[data-rac-qty]');
    var memberBtn = root.querySelector('[data-rac-member]');
    var goldModal = root.querySelector('[data-rac-goldmodal]');

    function openGold() {
      if (!goldModal) return;
      if (typeof goldModal.showModal === 'function') goldModal.showModal();
      else goldModal.setAttribute('open', '');
      /* showModal() focuses the first focusable DESCENDANT — the close button —
         leaving a UA focus ring drawn round it. Focus the dialog itself
         (tabindex="-1") so nothing is ringed, without losing the focus trap. */
      goldModal.focus({ preventScroll: true });
    }

    function closeGold() {
      if (!goldModal) return;
      if (typeof goldModal.close === 'function') goldModal.close();
      else goldModal.removeAttribute('open');
    }

    if (goldModal) {
      /* The dialog element IS the backdrop area, so a click whose target is the
         dialog itself landed outside the card. */
      goldModal.addEventListener('click', function (e) {
        if (e.target === goldModal) closeGold();
      });
      /* Space/Enter on the (i), which is a span with role="button". */
      var infoEl = root.querySelector('[data-rac-goldinfo]');
      if (infoEl) {
        infoEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openGold(); }
        });
      }
    }

    var pack = !hasPacks ? 1 : (PACKS.length > 1 ? PACKS[1].qty : PACKS[0].qty);
    var member = false;

    function renderPacks() {
      if (!hasPacks) return;
      packEls.forEach(function (el) {
        var qty = parseInt(el.dataset.racPack, 10);
        var pct = effectivePct(parseFloat(el.dataset.pct) || 0);
        var on = qty === pack;

        el.classList.toggle('is-on', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');

        var unit = unitCents(BASE, pct);
        var unitEl = el.querySelector('[data-rac-unit]');
        var totalEl = el.querySelector('[data-rac-total]');
        var wasEl = el.querySelector('[data-rac-was]');

        if (unitEl) unitEl.textContent = money(unit) + '/pair';
        if (totalEl) totalEl.textContent = money(unit * qty);
        /* No strike-through on a pack that saves nothing — the export emits an
           empty string for `compare` when pct is 0, and an empty <s> would
           still paint its own line. */
        if (wasEl) wasEl.textContent = pct > 0 ? money(BASE * qty) : '';
      });

      if (qtyEl) qtyEl.value = String(pack);
      renderSticky();
    }

    /* ---------- sticky add to cart ----------
       Title and price mirror the SELECTED pack, so the bar always quotes what
       the button above it would add. The export builds the title as
       `'Grip Socks ' + length + ' ' + colour + ' · ' + packSel.title`; here the
       product title carries the first part and the pack card supplies the rest,
       so a merchant renaming the product does not strand a hardcoded string. */
    var stickyEl = root.querySelector('[data-rac-sticky]');
    var stickyPackEl = root.querySelector('[data-rac-sticky-pack]');
    var stickyPriceEl = root.querySelector('[data-rac-sticky-price]');
    var stickyBtn = root.querySelector('[data-rac-sticky-atc]');

    function renderSticky() {
      if (!stickyEl) return;
      var onEl = root.querySelector('[data-rac-pack].is-on');
      var pct = effectivePct(onEl ? parseFloat(onEl.dataset.pct) || 0 : 0);
      if (stickyPriceEl) stickyPriceEl.textContent = money(unitCents(BASE, pct) * pack);
      if (stickyPackEl) {
        var label = onEl && onEl.querySelector('.rac__packtitle');
        stickyPackEl.textContent = label ? ' \u00b7 ' + label.textContent.trim() : '';
      }
      /* Unhidden only once it holds a price — otherwise a slow first paint can
         flash an empty bar. */
      if (stickyEl.hasAttribute('hidden')) stickyEl.removeAttribute('hidden');
    }

    root.addEventListener('click', function (e) {
      var packEl = e.target.closest('[data-rac-pack]');
      if (packEl) {
        pack = parseInt(packEl.dataset.racPack, 10);
        renderPacks();
        return;
      }

      /* The (i) opens the modal WITHOUT ticking the box. It sits inside the
         row, so the click has to be claimed before the row sees it. */
      if (e.target.closest('[data-rac-goldinfo]')) {
        e.preventDefault();
        e.stopPropagation();
        openGold();
        return;
      }

      if (e.target.closest('[data-rac-goldclose]')) {
        closeGold();
        return;
      }

      if (memberBtn && e.target.closest('[data-rac-member]')) {
        member = !member;
        memberBtn.setAttribute('aria-pressed', member ? 'true' : 'false');
        /* NO detail to open — on this page the perks live in the modal behind
           the (i), not in an inline disclosure. Ticking the box only reprices. */
        renderPacks();
        return;
      }

      var thumb = e.target.closest('[data-rac-thumb]');
      if (thumb) {
        selectShot(parseInt(thumb.dataset.racThumb, 10));
      }
    });

    /* ---------- gallery ----------
       Swiper, matching reformly-bp's PDP gallery: swipe on touch, a
       follow-cursor arrow on desktop.

       loop + realIndex: cloned slides make `activeIndex` count the clones, so
       the thumb strip tracks the wrong shot. `slideToLoop` is the clone-aware
       seek. loopAdditionalSlides/loopPreventsSliding are bp's values — a spare
       slide either side so a reversal mid-transition does not re-translate,
       and reverse swipes are not swallowed. */
    /* Declared HERE, not assumed. The cursor handlers below read it, and it
       was missing — every mousemove threw a ReferenceError, so the hover arrow
       never appeared at all. reformly-bb.js declares its own; this file had
       been copied from it without this line. */
    var deskMQ = window.matchMedia('(min-width: 900px)');

    var galleryEl = root.querySelector('[data-rac-swiper]');
    var thumbEls = [].slice.call(root.querySelectorAll('.rac__thumb'));
    var gallery = null;

    function paintThumbs(i) {
      thumbEls.forEach(function (el, n) { el.classList.toggle('is-on', n === i); });
    }

    /* Swiper 11 computes `loopedSlides = slidesPerGroup + loopAdditionalSlides`
       and shifts that many slides end-to-end on every loopFix. At
       loopAdditionalSlides: 1 that is 2, so a TWO-shot product shifts its
       whole set at once and the carousel stalls on one image — reported on
       the gift card, which ships exactly two. Clamp it: the spare slide is
       only there to stop a mid-transition reversal re-translating, and with
       two slides there is no room for one. */
    var galleryShots = galleryEl ? galleryEl.querySelectorAll('.swiper-slide').length : 0;

    if (galleryEl && typeof window.Swiper === 'function' && galleryShots > 1) {
      gallery = new window.Swiper(galleryEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 320,
        loop: true,
        loopAdditionalSlides: galleryShots > 2 ? 1 : 0,
        loopPreventsSliding: false,
        lazyPreloadPrevNext: 2,
        touchReleaseOnEdges: true,
        threshold: 4,
        touchAngle: 40,
        longSwipesRatio: 0.25,
        resistanceRatio: 0.6,
        a11y: { enabled: true },
        on: {
          slideChange: function () { paintThumbs(this.realIndex); }
        }
      });
    }

    function selectShot(i) {
      if (gallery) gallery.slideToLoop(i);
      paintThumbs(i);
    }

    /* ---------- gallery hover cursor (desktop) ----------
       Ported from reformly-bp-hero.js. The glyph flips over the left half and
       a click pages whichever way it points. Bound once; reads `gallery` live
       so it no-ops for single-image products. */
    var cursorEl = root.querySelector('[data-rac-cursor]');
    var cursorSvg = cursorEl && cursorEl.querySelector('svg');
    var ptrIn = false;

    if (galleryEl && cursorEl) {
      galleryEl.addEventListener('mouseenter', function () { ptrIn = true; });
      galleryEl.addEventListener('mouseleave', function () {
        ptrIn = false;
        cursorEl.classList.remove('is-visible');
      });
      galleryEl.addEventListener('mousemove', function (e) {
        if (!deskMQ.matches || !gallery) return;
        ptrIn = true;
        var r = galleryEl.getBoundingClientRect();
        cursorEl.classList.add('is-visible');
        cursorEl.style.left = e.clientX + 'px';
        cursorEl.style.top = e.clientY + 'px';
        if (cursorSvg) {
          cursorSvg.style.transform = (e.clientX - r.left) < r.width / 2 ? 'scaleX(-1)' : '';
        }
      });
      galleryEl.addEventListener('click', function (e) {
        if (!deskMQ.matches || !gallery) return;
        var r = galleryEl.getBoundingClientRect();
        if (e.clientX - r.left >= r.width / 2) gallery.slideNext();
        else gallery.slidePrev();
      });
    }

    /* ---------- review spotlight ----------
       SWIPER, not a display-toggle. The card must be swipeable on touch, which
       arrows alone are not, and the bundle is already loaded for the gallery.

       `loop` + `autoplay` reproduce the export's timer:

         this._spotTimer = setInterval(() => this.setState(st => ({
           spot: ((st.spot || 0) + 1) % REVIEWS.length
         })), 5000);

       and go one further — the export CLAMPS its arrows (`spotlightHasPrev` is
       `spot > 0`), which made the last of six reviews a dead end. Swiper's loop
       wraps both the timer and the arrows.

       `disableOnInteraction: false` so a swipe or an arrow press re-arms the
       timer rather than killing it for the rest of the session. */
    var spotEl = root.querySelector('[data-rac-spotswiper]');
    var spotPrev = root.querySelector('[data-rac-spot-prev]');
    var spotNext = root.querySelector('[data-rac-spot-next]');
    var spotItems = spotEl ? spotEl.querySelectorAll('[data-rac-spotitem]') : [];

    if (spotEl && spotItems.length > 1 && typeof window.Swiper === 'function') {
      /* Read at call time, not once at boot — the OS setting can change while
         the page is open, and the arrows keep working either way. */
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      new window.Swiper(spotEl, {
        slidesPerView: 1,
        loop: true,
        /* One spare clone each side, as the gallery uses: a reversal
           mid-transition then does not re-translate the track. */
        loopAdditionalSlides: 1,
        autoHeight: false,
        watchOverflow: true,
        /* Same as the reviews rail below: autoplay yields to the reader on
           first interaction and pauses on hover. */
        autoplay: reduced ? false : {
          delay: 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true
        },
        navigation: (spotPrev && spotNext)
          ? { prevEl: spotPrev, nextEl: spotNext }
          : false
      });
    } else if (spotItems.length) {
      /* Swiper missing (script blocked, or a single review): show the first and
         leave the arrows inert rather than rendering an empty card. */
      spotItems[0].classList.add('is-on');
      if (spotPrev) spotPrev.disabled = true;
      if (spotNext) spotNext.disabled = true;
    }

    /* ---------- zoom ----------
       Opens the current shot at full size. No lightbox library — the gallery
       already holds the full-resolution URL on each thumb. */
    var zoomBtn = root.querySelector('[data-rac-zoom]');
    if (zoomBtn && galleryEl) {
      zoomBtn.addEventListener('click', function (e) {
        /* The gallery's own click handler pages the slide — do not let the
           zoom button do both. */
        e.stopPropagation();
        var active = galleryEl.querySelector('.swiper-slide-active img') || galleryEl.querySelector('img');
        var src = active && (active.currentSrc || active.src);
        if (src) window.open(src, '_blank', 'noopener');
      });
    }

    /* ---------- add to cart ----------
       The membership is a SUBSCRIPTION. Without `selling_plan` on the line,
       /cart/add.js takes the variant as a one-time purchase: the buyer is
       charged once, no subscription is created, and nothing surfaces the
       mistake until the second month never bills. */
    var form = root.querySelector('[data-rac-form]');
    var atc = root.querySelector('[data-rac-atc]');

    if (form && atc) {
      /* NO SUBMIT EVENT IS EVER FIRED.

         The first attempt at this stopped the click and then called
         `form.dispatchEvent(new Event('submit'))`. That does not help: a
         listener bound directly to the form still receives a dispatched event
         (`bubbles: false` only stops it travelling upward), so an app listening
         on the form's submit was handed the event by us.

         So the add runs as a plain function call. The <form> stays in the
         markup for the no-JS case, but nothing here ever submits it and no
         submit event exists for anything else to hear. */
      /* `pressedEl` — the control the shopper actually touched, when it is not
         the main CTA. The single-item button passes itself.

         SPINNER AND LOCK ARE DIFFERENT SETS, deliberately. Every add button on
         the page has to be disabled for the duration or a second press posts a
         second add, but only the one that was pressed should spin: putting the
         spinner on the main CTA when the shopper pressed "Pilates Mat Only
         $29.95" animates a control they are not looking at and leaves the one
         under their finger inert. Same reasoning the sticky bar's note below
         already gives for itself. */
      function addToCart(pressedEl) {
        var variantEl = root.querySelector('[data-rac-variant]');
        if (!variantEl) return;

        var locked = [atc];
        /* The sticky bar is the button the shopper actually pressed in this
           case, so it has to show the state — delegating the click to the
           main CTA put the spinner on a button that was scrolled off. */
        if (stickyBtn) locked.push(stickyBtn);
        if (pressedEl && locked.indexOf(pressedEl) === -1) locked.push(pressedEl);

        var spinning = pressedEl ? [pressedEl] : locked.slice();

        locked.forEach(function (el) { el.disabled = true; });
        spinning.forEach(function (el) { el.classList.add('is-loading'); });

        /* Read the quantity from the SELECTED PACK CARD, not from the hidden
           [name="quantity"] input.

           Still the DOM rather than the closure, for the original reason: the
           card is what the user actually sees selected, so "what is sent" and
           "what is shown" cannot desync. But the hidden input is NOT ours
           alone — Kaching Bundles runs with `keepQuantityInput: false`, which
           means its widget writes its own selected bundle quantity into any
           [name="quantity"] on the page. Reading it back handed the cart
           Kaching's number: picking 4 pairs posted 5, the quantity of its
           default "5 Pack" bar, on a ladder that has no 5 in it at all.

           `.rac__pack.is-on` is ours and nothing else touches it. */
        var onEl = root.querySelector('[data-rac-pack].is-on');
        var qty = onEl ? parseInt(onEl.dataset.racPack, 10) : pack;
        if (!qty || qty < 1) qty = pack;

        var items = [{ id: parseInt(variantEl.value, 10), quantity: qty }];

        /* THE BUNDLE'S OWN LINES. `syncForm()` writes one
           `input[name="items[][id]"]` per filled slot, which is what the
           <form> would post without JS — but nothing submits the form, so the
           fetch below has to read them too. It did not, and a three-accessory
           bundle added exactly one thing: the product being viewed.

           Quantity 1 each. Two slots holding the same accessory post the same
           id twice and Shopify merges them into one line of 2. */
        if (form) {
          [].slice.call(form.querySelectorAll('[data-rac-bundleitem]')).forEach(function (el) {
            var id = parseInt(el.value, 10);
            if (id) items.push({ id: id, quantity: 1 });
          });
        }

        if (member && memberBtn) {
          var mv = parseInt(memberBtn.dataset.variant, 10);
          var mp = parseInt(memberBtn.dataset.sellingPlan, 10);
          if (mv) {
            var line = { id: mv, quantity: 1 };
            if (mp) line.selling_plan = mp;
            items.push(line);
          }
        }

        /* ?kaching_bundles=true — opt OUT of Kaching Bundles' cart interceptor.
           Its app embed replaces window.fetch (and XMLHttpRequest) and rewrites
           the body of any request whose URL contains "cart/add", merging its own
           bundle items over ours. That is why picking 4 pairs added 5: the
           quantity posted here was being overwritten before it left the page.

           The flag is Kaching's own escape hatch, not a hack — its matcher is
             _isInterceptableUrl(t) { return t.includes("cart/add")
               && !t.includes("kaching_bundles=true") && ... }
           and its own cart code uses it for the same reason.

           This page builds its own bundle UI and posts the exact lines it wants,
           so it must never be merged with Kaching's. Shopify ignores the unknown
           query param. Same flag is on reformly-bb.js for the same reason. */
        fetch('/cart/add.js?kaching_bundles=true', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed: ' + r.status);
            return r.json();
          })
          .then(function () {
            if (window.rypCart) { window.rypCart.open(); }
            else {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.body.classList.add('js-ajax-cart-open');
            }
          })
          .catch(function (err) {
            /* NO form.submit() fallback here.

               /cart/add.js is not atomic from the page's point of view: a
               request can add its lines and still reject (a rejected
               subscription line, a 422 on one item), and re-posting the form
               then adds the socks A SECOND TIME. That is a silent double-add,
               which is worse than a visible failure — so surface the error and
               let the shopper press again. */
            console.error('[rac] add to cart failed:', err);
          })
          .then(function () {
            locked.forEach(function (el) { el.disabled = false; });
            spinning.forEach(function (el) { el.classList.remove('is-loading'); });
          });
      }

      /* Exposed so the single-item button can run the SAME add rather than
         synthesising a click on this CTA.

         It used to call `cta.click()`, which worked but spun the main button
         instead of the one under the shopper's finger. A second copy of the
         add is not the alternative — everything here (the Kaching opt-out, the
         bundle lines, the membership line, the drawer open, the failure
         handling) has to stay in one function or the two paths drift. So the
         function is published on the root element, which initOffers() already
         holds a reference to.

         On `root` rather than `window`: the section can legally render twice,
         and a global would have the second instance adding the first one's
         variant. */
      root.__racAdd = addToCart;

      /* Capture phase, so the press is claimed before any listener bound later
         on the button or the form can see it. */
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (atc.disabled) return;
        addToCart();
      }, true);

      /* Belt and braces: if anything still manages to submit the form — an
         Enter press in a field, another script calling submit() — swallow it
         rather than letting the browser post a second add. */
      form.addEventListener('submit', function (e) { e.preventDefault(); }, true);
    }

    /* Reveal exactly as the export does: when the MAIN button's bottom edge has
       passed the top of the viewport. A scroll-distance threshold would show the
       bar while the real CTA is still on screen, stacking two identical buttons.

       rAF-throttled — `onScroll` fires per frame on iOS momentum, and
       getBoundingClientRect() forces layout each time. */
    if (stickyEl && atc) {
      var stickyTick = false;

      var syncSticky = function () {
        stickyTick = false;
        stickyEl.classList.toggle('is-on', atc.getBoundingClientRect().bottom < 0);
      };

      window.addEventListener('scroll', function () {
        if (stickyTick) return;
        stickyTick = true;
        requestAnimationFrame(syncSticky);
      }, { passive: true });

      window.addEventListener('resize', syncSticky, { passive: true });
      syncSticky();

      /* Delegate to the real button rather than duplicating the add: one code
         path means the loading state, the membership line and the error
         handling cannot drift between the two controls. */
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (!atc.disabled) atc.click();
        });
      }
    }


    /* ---------- headroom ----------
       The sticky gallery has to clear whatever is actually pinned at the top.
       sticky-header.js publishes --header-height, but only recomputes it when
       crossing 990px, so it is stale for most of the range. Measuring the
       element that really pins is always current.

       THE V4 NAV FIRST. The theme's header is now `display: none` sitewide,
       so measuring it returned 0 and this published `--rac-headroom: 0px`,
       overriding the stylesheet's value — the gallery pinned at the very top
       and slid under the nav. The nav is fixed and offset by the announcement
       bar, so its BOTTOM edge is the clearance, announcement included.

       The old header is kept as the fallback for any template that still
       renders it without the nav. */
    function headerEl() {
      return document.querySelector('.rfn') ||
        document.querySelector('sticky-header, .section-header, #shopify-section-header');
    }

    function syncHeadroom() {
      var pad = 0;
      var h = headerEl();
      if (h) {
        var pos = getComputedStyle(h).position;
        var always = h.getAttribute && h.getAttribute('data-sticky-type') === 'always';
        if (always || pos === 'sticky' || pos === 'fixed') {
          var r = h.getBoundingClientRect();
          /* bottom, not height: the nav sits below the announcement bar, and
             the gallery has to clear both. */
          pad = Math.max(0, r.bottom);
        }
      }
      root.style.setProperty('--rac-headroom', Math.round(pad) + 'px');
    }

    syncHeadroom();
    window.addEventListener('load', syncHeadroom, { passive: true });
    window.addEventListener('resize', syncHeadroom, { passive: true });
    if (window.ResizeObserver) {
      var hEl = headerEl();
      if (hEl) new ResizeObserver(syncHeadroom).observe(hEl);
    }

    renderPacks();
  }


  /* ---------------- reviews carousel ----------------
     Shifts the track by whole cards. The card width is set in CSS from the
     export's own rule — `visible = w < 700 ? 1 : (w < 1100 ? 2 : 3)` with a
     20px gap — so the step is measured off a rendered card rather than
     recomputed here; one source of truth, and it cannot drift from the CSS.

     Autoplay every 5000ms, wrapping, exactly as `restartRev()` does. It stops
     on interaction: an auto-advancing carousel that fights the reader is worse
     than none. */
  function initReviews(root) {
    /* SWIPER. Was a hand-rolled translate3d track with arrows and no touch
       gesture at all — on a phone the only way to reach review 2 was a 34px
       arrow. The bundle is already linked by this section.

       Card widths stay in CSS (`.racr__card`), so `slidesPerView: 'auto'` reads
       each slide's measured width rather than Swiper computing one: the
       breakpoints are `calc(100% - 65px)` / `calc((100% - 20px)/2)` /
       `calc((100% - 40px)/3)`, which no single slidesPerView number expresses.

       `spaceBetween` mirrors the gap the track used to carry — 12 on the phone,
       20 from two-up — and the card calc()s are written against those, so the
       two must move together.

       Autoplay 5s and wrapping, which is the export's own review timer:
         this._revTimer = setInterval(() => this.setState(st => ({
           review: st.review >= (this._maxReview || 0) ? 0 : st.review + 1
         })), 5000);
       `disableOnInteraction: false` so a swipe re-arms it instead of killing
       it for the session. */
    var viewport = root.querySelector('[data-racr-viewport]');
    var prev = root.querySelector('[data-racr-prev]');
    var next = root.querySelector('[data-racr-next]');
    if (!viewport) return;

    var slides = viewport.querySelectorAll('.racr__card');
    if (slides.length < 2) {
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }

    if (typeof window.Swiper !== 'function') {
      /* Script blocked or not yet parsed: the cards are still in the DOM and
         the track is a plain flex row, so they read as a static strip rather
         than vanishing. Arrows would do nothing, so they are disabled. */
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    new window.Swiper(viewport, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      /* LOOP, not rewind. The export's own timer snaps back to the first card:

           review: st.review >= (this._maxReview || 0) ? 0 : st.review + 1

         and mirroring that with `rewind` meant scrolling past the last card
         animated the whole track backwards to the start — six cards of travel
         in one transition, which reads as a glitch rather than a wrap.

         `loop` clones slides so the next card after the last is the first, with
         no long rewind. It was avoided here before because on Swiper 8 the
         clone/reorder fought `slidesPerView: 'auto'` and jumped to arbitrary
         positions mid-autoplay; the bundle is 11.2.10, where loop is
         re-implemented against measured slide widths and handles `auto`. Six
         slides against at most three visible is enough for it to fill. */
      loop: true,
      watchOverflow: true,
      /* AUTOPLAY YIELDS TO THE USER, permanently.

         The export's timer never stops, and mirroring that with
         `disableOnInteraction: false` meant the rail kept advancing while the
         reader was swiping it — the carousel moving under your finger, and a
         card you just chose pulled away 5s later.

         `true` stops autoplay for the rest of the session on the first swipe or
         arrow press. That is the standard behaviour for a commerce carousel:
         the timer exists to hint that there is more to see, and once the reader
         has understood that, it has done its job. `pauseOnMouseEnter` covers
         the desktop equivalent — reading a card should not time out. */
      autoplay: reduced ? false : {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      },
      navigation: (prev && next) ? { prevEl: prev, nextEl: next } : false,
      breakpoints: {
        700: { spaceBetween: 20 }
      }
    });
  }

  /* Does the cart drawer's quick view have data for this handle? It reads one
     inlined table plus whatever a section contributes; if the handle is in
     neither, the card must stay an ordinary link to the PDP. */
  function quickKnows(handle) {
    var els = [];
    var base = document.getElementById('ryp-cart-products');
    if (base) els.push(base);
    /* All of them — this page renders two rails, each contributing its own. */
    var extra = document.querySelectorAll('[data-ryp-products-extra]');
    for (var n = 0; n < extra.length; n++) els.push(extra[n]);

    for (var i = 0; i < els.length; i++) {
      try {
        var data = JSON.parse(els[i].textContent) || {};
        if (data[handle]) return true;
      } catch (e) {}
    }
    return false;
  }

  /* ---------------- rail scroll progress ----------------
     Thumb width = visible fraction of the rail; x = scroll position mapped
     across the remaining track. Hidden when nothing overflows, so a grid (the
     desktop also-like layout) shows no bar at all. */
  /* The scroll indicator. Its own function because it is OPTIONAL — only the
     bestsellers layout renders `[data-racl-bar]`. */
  function initRailBar(rail, bar, thumb) {
    function paint() {
      var view = rail.clientWidth;
      var full = rail.scrollWidth;
      var overflows = full - view > 1;
      bar.hidden = !overflows;
      if (!overflows) return;
      var track = bar.clientWidth;
      var w = Math.max(24, Math.round(view / full * track));
      var max = full - view;
      var x = max > 0 ? rail.scrollLeft / max * (track - w) : 0;
      thumb.style.width = w + 'px';
      thumb.style.transform = 'translate3d(' + Math.round(x) + 'px, 0, 0)';
    }

    rail.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    paint();
  }

  function initRail(root) {
    var rail = root.querySelector('.racl__rail');
    var bar = root.querySelector('[data-racl-bar]');
    var thumb = root.querySelector('[data-racl-thumb]');

    /* Guard the INDICATOR, not the whole function. This used to be
       `if (!rail || !bar || !thumb) return;`, which took the quick-view click
       binding below down with it whenever a layout had no indicator — so the
       alsolike rail had no modal at all and every card just navigated to the
       PDP. Only bestsellers renders the bar. */
    if (rail && bar && thumb) initRailBar(rail, bar, thumb);

    /* ---------- quick view on press ----------
       Ported from reformly-luna.js. The card stays a real <a> to the PDP and
       this only UPGRADES the click, so:
         - no cart drawer on the page -> the link works
         - a handle the drawer does not know -> the link works
         - cmd/ctrl/shift/middle click -> opens the PDP in a new tab, which is
           a real intent and must not be swallowed
       Capture phase, matching luna, so it runs before any inner handler. */
    root.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('[data-racl-quick]');
      if (!card) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      if (!window.rypCart || typeof window.rypCart.quickView !== 'function') return;
      if (!document.getElementById('ryp-quick')) return;

      var handle = card.getAttribute('data-racl-quick');
      if (!handle) return;

      /* Only claim the click if the quick view can actually SHOW this handle.
         openQuick() returns silently for a product it has no data for, so
         calling it after preventDefault() is what made the press do nothing at
         all — no modal and no navigation either. */
      if (!quickKnows(handle)) return;

      e.preventDefault();
      window.rypCart.quickView(handle);
    }, true);
  }

  /* ==========================================================================
     OPTION SELECTORS

     The product's own variants drive these. Picking a value rewrites the
     chosen option, finds the matching variant, writes its id into the form's
     hidden `id` field, and jumps the gallery to that variant's media.

     GALLERY SWAP IS A SCROLL, NOT A REBUILD. Every variant's media is
     already rendered in the Swiper, so there is nothing to re-render — which
     is what reformly-variant-gallery-sync has to do on the theme's own
     template, where only the selected variant's media exists. If a variant
     has no image of its own the map points at 0 and the gallery stays put;
     that is an admin gap, not a bug here.
     ========================================================================== */
  function initOptions(root) {
    var wrap = root.querySelector('[data-rac-opts]');
    if (!wrap) return;

    var blob = wrap.querySelector('[data-rac-variants]');
    var variants = [];
    try { variants = JSON.parse(blob.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var idField = root.querySelector('[data-rac-variant]');
    var swiperEl = root.querySelector('[data-rac-swiper]');
    var slidesEl = root.querySelector('[data-rac-slides]');
    var thumbsEl = root.querySelector('[data-rac-thumbs]');
    var offers = root.querySelector('[data-rac-offers]');

    var galleryBlob = root.querySelector('[data-rac-gallery-data]');
    var GALLERY = {};
    if (galleryBlob) {
      try { GALLERY = JSON.parse(galleryBlob.textContent); } catch (e) { GALLERY = {}; }
    }

    /* Seed from the markup rather than from variants[0]: the page may have
       been loaded with ?variant= and Liquid already resolved it. */
    var chosenOpts = [];
    [].slice.call(wrap.querySelectorAll('[data-rac-optvalue].is-on')).forEach(function (b) {
      chosenOpts[parseInt(b.dataset.opt, 10)] = b.dataset.value;
    });

    function match() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < chosenOpts.length; j++) {
          if (chosenOpts[j] !== undefined && v.options[j] !== chosenOpts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function apply() {
      var v = match();
      [].slice.call(wrap.querySelectorAll('[data-rac-optvalue]')).forEach(function (b) {
        var on = chosenOpts[parseInt(b.dataset.opt, 10)] === b.dataset.value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      [].slice.call(wrap.querySelectorAll('[data-rac-optname]')).forEach(function (el) {
        var i = parseInt(el.dataset.racOptname, 10);
        if (chosenOpts[i] !== undefined) el.textContent = chosenOpts[i];
      });
      if (!v) return;

      if (idField) idField.value = v.id;

      /* The bundle's locked first row shows the viewed product, so its
         colour has to follow the picker. */
      if (offers) {
        offers.dataset.mainColour = v.options.join(' / ');
        /* And the thumbnail, which this did not do: the row read "Pink" next
           to the purple mat Liquid had rendered, because only the label was
           rewritten. `image` comes off the same variant table — see the
           comment on it in reformly-acc-hero.liquid. Guarded, so a variant
           with no image of its own leaves the product's featured shot up
           rather than blanking the row. */
        if (v.image) offers.dataset.mainImage = v.image;
        /* Price too, not just the name: the bundle maths stands the viewed
           product into every empty slot, so a colour that costs more changes
           what the card quotes. */
        if (v.price !== undefined) offers.dataset.mainPrice = v.price;
        if (v.compare !== undefined) offers.dataset.mainCompare = v.compare;
        if (offers.__racRender) offers.__racRender();
      }

      paintGallery(v);
    }

    /* REBUILD, not scroll. Each variant has its OWN media list, so there is
       no index in a shared strip to scroll to — the slides and thumbs have
       to be replaced, which is what reformly-variant-gallery-sync does on the
       theme's own template for the same reason.

       Swiper is destroyed and rebuilt rather than `update()`d: it is in loop
       mode, so its cloned slides are in the wrapper too, and updating around
       clones belonging to the old list is what desynchronises the thumb
       strip. Rebuilding from clean markup avoids the whole class of bug. */
    function paintGallery(v) {
      var shots = GALLERY[String(v.id)];
      if (!shots || !shots.length || !slidesEl) return;

      var sw = swiperEl && swiperEl.swiper;
      var opts = sw ? sw.originalParams : null;
      if (sw) sw.destroy(true, true);

      slidesEl.textContent = '';
      shots.forEach(function (shot, i) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        var img = document.createElement('img');
        img.className = 'rac__mainimg';
        img.src = shot.big;
        img.alt = shot.alt || '';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.decoding = 'async';
        slide.appendChild(img);
        slidesEl.appendChild(slide);
      });

      if (thumbsEl) {
        thumbsEl.textContent = '';
        thumbsEl.hidden = shots.length < 2;
        shots.forEach(function (shot, i) {
          var li = document.createElement('li');
          li.className = 'rac__thumb' + (i === 0 ? ' is-on' : '');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'rac__thumbbtn';
          btn.setAttribute('data-rac-thumb', String(i));
          btn.setAttribute('data-src', shot.big);
          btn.setAttribute('aria-label', shot.alt || '');
          var img = document.createElement('img');
          img.src = shot.thumb;
          img.alt = shot.alt || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          btn.appendChild(img);
          li.appendChild(btn);
          var bar = document.createElement('span');
          bar.className = 'rac__thumbbar';
          bar.setAttribute('aria-hidden', 'true');
          li.appendChild(bar);
          thumbsEl.appendChild(li);
        });
      }

      if (opts && typeof window.Swiper === 'function') {
        /* Same clamp as the initial build: this variant's list may be shorter
           than the one the params were captured from. */
        opts.loopAdditionalSlides = shots.length > 2 ? 1 : 0;
        new window.Swiper(swiperEl, opts);
      }
    }

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-rac-optvalue]');
      if (!btn) return;
      chosenOpts[parseInt(btn.dataset.opt, 10)] = btn.dataset.value;
      apply();
    });
  }

  /* ==========================================================================
     ACCESSORY BUNDLE BUILDER

     Two offer cards; picking one reveals its slots; pressing an empty slot
     opens the picker; choosing fills it. Everything derives from two values —
     which offer is selected and what is in each slot — so the cards and the
     form can never disagree.

     THE PRODUCT BEING VIEWED TAKES THE FIRST ROW and cannot be changed or
     removed. That is the export's `rows[0]`: `{ key: 'main', canChange:
     false, cursor: 'default' }`, and its `bundleFull = (nSlots + 1) * UNIT`
     counts it — so "3 Accessories" is this mat plus two chosen ones, not
     three chosen ones.

     WHICH ITEM IS FREE IS DECIDED BY PRICE, NOT BY SLOT. The export marks the
     last slots free and labels them "Choose FREE Accessory", which only works
     because every accessory in it costs the same €29. Ours range from €24 to
     €39, and a BXGY discount rebates the CHEAPEST lines — so the card quotes
     the sum of the `slots + 1 - free` most expensive items in the bundle, and
     no slot claims to be free.

     WHAT THIS DOES NOT DO is make anything free. The form posts every
     accessory at its own price and a BXGY discount in admin rebates them,
     exactly as the sock builder works. Until those exist the cart charges for
     all of them; the price on the card is a prediction of what that discount
     will do.
     ========================================================================== */
  /* Shared by the pack ladder and the bundle builder — both format money and
     both read the same `data-money-format`. */
  function formatMoney(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.'));
  }

  function initOffers(root) {
    var wrap = root.querySelector('[data-rac-offers]');
    if (!wrap) return;

    var cards = [].slice.call(wrap.querySelectorAll('[data-rac-offer]'));
    if (!cards.length) return;

    var dialog = document.querySelector('[data-rac-picker]');
    var list = dialog && dialog.querySelector('[data-rac-picker-list]');
    var stepEl = dialog && dialog.querySelector('[data-rac-picker-step]');
    var singleBtn = wrap.querySelector('[data-rac-single]');
    var form = root.querySelector('[data-rac-form]');
    var rows = dialog ? [].slice.call(dialog.querySelectorAll('[data-rac-pick]')) : [];

    var fmt = root.dataset.moneyFormat || '${{amount}}';

    var main = {
      name: wrap.dataset.mainName || '',
      colour: wrap.dataset.mainColour || '',
      image: wrap.dataset.mainImage || '',
      price: parseInt(wrap.dataset.mainPrice, 10) || 0,
      compare: parseInt(wrap.dataset.mainCompare, 10) || parseInt(wrap.dataset.mainPrice, 10) || 0
    };

    var chosen = cards.map(function (c) {
      return new Array(parseInt(c.dataset.slots, 10) || 0).fill(null);
    });
    var active = -1;
    var editing = -1;

    /* ---------- what the bundle costs ----------
       Shopify's Buy-X-Get-Y discounts the CHEAPEST qualifying lines, so the
       buyer pays for the most expensive ones. The card therefore quotes the
       sum of the `slots + 1 - free` highest prices in the bundle, against the
       sum of every line's compare-at.

       AN EMPTY SLOT COUNTS AS ANOTHER OF THE VIEWED PRODUCT. Without that the
       card can only quote what has been picked so far, so "3 Accessories"
       opens at the price of one mat — which reads as the bundle being
       cheaper than it is. Standing in the viewed product instead gives the
       design's shape on load (2x the price, 3x the compare-at on a 3-bundle)
       and converges on the truth as the buyer fills the slots:

         nothing picked   main, main, main   pay 2, compare 3
         one picked       main, pick, main   pay the 2 dearest
         both picked      main, p1, p2       pay the 2 dearest

       The same rule gives 3x / 5x on the five-accessory card.

       It is still an ESTIMATE until the slots are full, and it is an estimate
       of what a BXGY discount will do — none exists yet, so right now the cart
       charges the compare-at figure. */
    function bundleSums(card, picks) {
      var slots = parseInt(card.dataset.slots, 10) || 0;
      var free = parseInt(card.dataset.free, 10) || 0;

      var items = [{ price: main.price, compare: main.compare }];
      for (var i = 0; i < slots; i++) {
        var p = (picks || [])[i];
        items.push(p ? { price: p.price || 0, compare: p.compare || p.price || 0 }
                     : { price: main.price, compare: main.compare });
      }

      var compare = 0;
      items.forEach(function (it) { compare += it.compare; });

      var prices = items.map(function (it) { return it.price; })
        .sort(function (a, b) { return b - a; });

      var paid = prices.length - free;
      if (paid < 1) paid = prices.length;

      var price = 0;
      prices.forEach(function (c, i) { if (i < paid) price += c; });

      return { price: price, compare: compare };
    }

    /* ---------- the sticky bar quotes the BUNDLE ----------
       init()'s own renderSticky() only runs for the pack ladder, and an
       accessory template has no packs — so on these pages nothing ever wrote
       a price into the bar or took its `hidden` off, and it never appeared at
       all. The bundle owns it here.

       Three accessories means three numbers worth showing: the bundle total,
       the undiscounted sum struck through, and what that saves. Choosing
       "Just this item" collapses it back to the product's own price. */
    var stickyEl = root.querySelector('[data-rac-sticky]');
    var stickyPackEl = root.querySelector('[data-rac-sticky-pack]');
    var stickyPriceEl = root.querySelector('[data-rac-sticky-price]');
    var stickyWasEl = root.querySelector('[data-rac-sticky-was]');
    var stickySaveEl = root.querySelector('[data-rac-sticky-save]');

    function syncSticky() {
      if (!stickyEl) return;

      var price;
      var compare;
      var suffix = '';

      if (active < 0) {
        price = main.price;
        compare = main.compare;
      } else {
        var sums = bundleSums(cards[active], chosen[active]);
        price = sums.price;
        compare = sums.compare;
        var titleEl = cards[active].querySelector('.rac__offertitle');
        if (titleEl) suffix = ' \u00b7 ' + titleEl.textContent.trim();
      }

      var saved = compare - price;
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(price, fmt);
      if (stickyPackEl) stickyPackEl.textContent = suffix;
      if (stickyWasEl) {
        stickyWasEl.textContent = formatMoney(compare, fmt);
        stickyWasEl.hidden = saved <= 0;
      }
      if (stickySaveEl) {
        stickySaveEl.textContent = 'Save ' + formatMoney(saved, fmt);
        stickySaveEl.hidden = saved <= 0;
      }

      /* Unhidden only once it holds a price — otherwise a slow first paint can
         flash an empty bar. The .is-on scroll toggle still decides when it
         slides up. */
      if (stickyEl.hasAttribute('hidden')) stickyEl.removeAttribute('hidden');
    }

    function priceCard(card, i) {
      var sums = bundleSums(card, chosen[i]);
      var priceEl = card.querySelector('.rac__offerprice');
      var cmpEl = card.querySelector('.rac__offercompare');
      var saveEl = card.querySelector('.rac__offersave');
      var saved = sums.compare - sums.price;

      if (priceEl) priceEl.textContent = formatMoney(sums.price, fmt);
      /* Both stay in the layout whatever they say. `.rac__offersub` is pulled
         up 23px to tuck under the title, which only clears the title because
         the price column is two lines tall — hiding the compare-at collapsed
         it to one and the subline landed ON the title. */
      if (cmpEl) cmpEl.textContent = saved > 0 ? formatMoney(sums.compare, fmt) : '';
      if (saveEl) {
        saveEl.textContent = saved > 0 ? 'SAVE ' + Math.round(saved / sums.compare * 100) + '%' : '';
        saveEl.hidden = saved <= 0;
      }
    }

    function row(idx, data, locked) {
      var el = document.createElement('div');
      el.className = 'rac__slot' + (data ? ' is-filled' : '') + (locked ? ' is-locked' : '');

      var box = document.createElement('span');
      box.className = 'rac__slotbox';
      if (data) {
        var img = document.createElement('img');
        img.className = 'rac__slotimg';
        img.src = data.image; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
        box.appendChild(img);
      } else {
        box.innerHTML = '<span class="rac__slotplus" aria-hidden="true">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>';
      }

      var info = document.createElement('span');
      info.className = 'rac__slotinfo';
      if (data) {
        var nameEl = document.createElement('span');
        nameEl.className = 'rac__slotname';
        nameEl.textContent = data.name;
        var meta = document.createElement('span');
        meta.className = 'rac__slotmeta';
        var col = document.createElement('span');
        col.textContent = data.colour || '';
        meta.appendChild(col);
        if (!locked) {
          var ch = document.createElement('span');
          ch.className = 'rac__slotchange';
          ch.textContent = 'Change';
          meta.appendChild(ch);
        }
        info.appendChild(nameEl);
        info.appendChild(meta);
      } else {
        var cta = document.createElement('span');
        cta.className = 'rac__slotcta';
        cta.textContent = 'Choose Accessory';
        info.appendChild(cta);
      }

      el.appendChild(box);
      el.appendChild(info);

      if (locked) return el;

      if (data) {
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'rac__slotremove';
        rm.setAttribute('aria-label', 'Remove ' + data.name);
        rm.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
        rm.addEventListener('click', function (e) {
          e.stopPropagation();
          chosen[active][idx] = null;
          render();
        });
        el.appendChild(rm);
      }
      el.addEventListener('click', function () { openPicker(idx); });
      return el;
    }

    function render() {
      cards.forEach(function (card, i) {
        var on = i === active;
        var btn = card.querySelector('[data-rac-offerpick]');
        card.classList.toggle('is-on', on);
        if (btn) btn.setAttribute('aria-checked', on ? 'true' : 'false');

        var holder = card.querySelector('[data-rac-slots]');
        if (!holder) return;
        holder.hidden = !on;
        holder.textContent = '';
        if (!on) return;

        /* The viewed product first, locked. */
        holder.appendChild(row(-1, main, true));

        chosen[i].forEach(function (data, idx) {
          holder.appendChild(row(idx, data, false));
        });
      });
      cards.forEach(priceCard);
      if (singleBtn) {
        singleBtn.classList.toggle('is-on', active === -1);
        /* "Weight Bands Only $34.95" — repainted from the CURRENT variant.

           `main.price` is refreshed by __racRender(), which initOptions calls
           on every colour/weight pick, so this tracks the picker for free. The
           `[price]` token is written by the section; a custom single_label
           without one simply has nothing to replace and stays as authored.
           See the comment on that markup in reformly-acc-hero.liquid. */
        var singleLbl = singleBtn.querySelector('[data-rac-single-label]');
        var singleTpl = singleBtn.dataset.racSingleTpl;
        if (singleLbl && singleTpl) {
          singleLbl.textContent = singleTpl.replace('[price]', formatMoney(main.price, fmt));
        }
      }
      syncForm();
      syncSticky();
    }

    /* The chosen accessories ride along as `items[][id]` inputs, the shape
       /cart/add accepts for a multi-line add. The viewed product stays in the
       form's own `id` field — it is the main row, not an extra line. */
    function syncForm() {
      if (!form) return;
      [].slice.call(form.querySelectorAll('[data-rac-bundleitem]')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });
      if (active < 0) return;
      chosen[active].forEach(function (data) {
        if (!data) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'items[][id]';
        input.value = data.variant;
        input.setAttribute('data-rac-bundleitem', '');
        form.appendChild(input);
      });
    }

    /* Rows repaint per OPEN SLOT: which row reads as selected depends on what
       is already in the slot being filled. */
    function paintRows() {
      if (!dialog || active < 0) return;
      var current = chosen[active][editing];
      rows.forEach(function (b) {
        b.classList.toggle('is-on', !!current && b.dataset.variant === current.variant);
      });
    }

    function openPicker(idx) {
      if (!dialog || active < 0) return;
      editing = idx;
      var card = cards[active];
      var slots = parseInt(card.dataset.slots, 10) || 0;
      /* The export's `'Accessory ' + (openSlot + 2) + ' of ' + (nSlots + 1)`:
         the viewed product is accessory 1, so the first empty slot is 2. */
      if (stepEl) stepEl.textContent = 'Accessory ' + (idx + 2) + ' of ' + (slots + 1);
      paintRows();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.focus({ preventScroll: true });

      /* Two frames: one for showModal()'s layout to land, one for it to settle,
         so the bar is measured against a row that has a width. */
      requestAnimationFrame(function () {
        requestAnimationFrame(initChipRail);
      });

      /* OPEN ON THE ROW THAT IS ALREADY IN THIS SLOT. Pressing "Change" on a
         filled slot and landing at the top of a nine-row list hides the thing
         being changed — the export opens with it in view.

         Measured against the list's own scrollTop rather than
         scrollIntoView(): that walks every scrollable ancestor, and the page
         behind the dialog is one of them, so the PDP scrolls too and the
         buy box has moved when the sheet closes.

         A row hidden by the filter has no offset worth scrolling to, so that
         falls back to the top. */
      if (list) {
        var current = chosen[active][editing];
        var target = null;
        if (current) {
          for (var i = 0; i < rows.length; i++) {
            if (!rows[i].hidden && rows[i].dataset.variant === current.variant) {
              target = rows[i];
              break;
            }
          }
        }
        if (target) {
          var mid = target.offsetTop - (list.clientHeight - target.offsetHeight) / 2;
          var max = list.scrollHeight - list.clientHeight;
          list.scrollTop = Math.max(0, Math.min(mid, max));
        } else {
          list.scrollTop = 0;
        }
      }
    }

    /* THE FILTER CHIP RAIL — press-and-drag, plus the 2px bar under it.

       NOT A SWIPER, and that is a reversal. It was one briefly, for the mouse
       drag a bare overflow-x row does not give. Inside this <dialog> Swiper's
       MOUSE path computes its first setTranslate as NaN and latches it into
       swiper.translate, so the row dies on the first drag and never recovers.
       Measured at 1440 against every combination of freeMode / sticky /
       resistance / threshold and against the `rails` preset itself; the TOUCH
       path is fine, and the same preset on the same page outside the dialog is
       fine. So the row keeps the platform's scroller — which already handled
       touch, trackpad and wheel — and this adds the two things it lacked.

       Bound once per element via a flag rather than guarded by the caller:
       reformly-acc.js is linked twice on this template and every listener in
       it is otherwise bound twice, which on a drag handler means two
       scrollLeft writes per pointermove.

       SLOP BEFORE DRAG. A press that moves less than 4px is a tap on a chip
       and must stay one, so .is-dragging (which cancels the chip press state
       and flips the cursor) is only set past that, and the click is only
       suppressed if it was set. Without that the row became unclickable. */
    function initChipRail() {
      var rail = dialog && dialog.querySelector('[data-rac-chiprail]');
      if (!rail || rail.dataset.racChiprailReady === '1') return;
      rail.dataset.racChiprailReady = '1';

      var bar = dialog.querySelector('[data-rac-chipbar]');
      var thumb = dialog.querySelector('[data-rac-chipthumb]');
      var SLOP = 4;
      var down = false, moved = false, startX = 0, startScroll = 0, pid = null;

      function paint() {
        if (!bar || !thumb) return;
        var total = rail.scrollWidth, visible = rail.clientWidth;
        /* Nothing to scroll: hide the bar outright. A full-width thumb under a
           row that cannot move reads as a broken control. */
        if (total <= visible + 1) { bar.hidden = true; return; }
        bar.hidden = false;
        var ratio = visible / total;
        var progress = rail.scrollLeft / (total - visible);
        /* scaleX + translate rather than width/left: both are composited, so
           this stays off the layout path while the finger is down. The thumb
           is width:100% with transform-origin:left, so scaleX IS its width.

           TRANSLATED IN PIXELS, not percent. A percentage here resolves
           against the thumb's own UNSCALED border box — the full track width —
           so the offset came out 1/ratio too large and the thumb ran off the
           right-hand end of the card at full scroll. The travel is simply the
           track minus the thumb: barW * (1 - ratio). */
        var barW = bar.clientWidth;
        thumb.style.transform =
          'translateX(' + (progress * barW * (1 - ratio)) + 'px) scaleX(' + ratio + ')';
      }

      var queued = false;
      function onScroll() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; paint(); });
      }
      rail.addEventListener('scroll', onScroll, { passive: true });

      /* Only when there is something to scroll. Below 900 the row WRAPS
         instead of scrolling (see reformly-acc.css), so scrollWidth equals
         clientWidth — and without this test a 4px finger wobble on a chip set
         .is-dragging and the click handler below then swallowed the tap,
         making the filters unusable on a phone. */
      function scrollable() {
        return rail.scrollWidth > rail.clientWidth + 1;
      }

      rail.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        if (!scrollable()) return;
        down = true; moved = false;
        startX = e.clientX;
        startScroll = rail.scrollLeft;
        pid = e.pointerId;
      });

      rail.addEventListener('pointermove', function (e) {
        if (!down || e.pointerId !== pid) return;
        var dx = e.clientX - startX;
        if (!moved) {
          if (Math.abs(dx) < SLOP) return;
          moved = true;
          rail.classList.add('is-dragging');
          /* Captured only once the gesture is really a drag, so a plain tap
             still delivers its click to the chip. */
          if (rail.setPointerCapture) { try { rail.setPointerCapture(pid); } catch (err) {} }
        }
        /* preventDefault stops the browser running its own pan/selection on
           the same pointer. Not passive, for that reason. */
        e.preventDefault();
        rail.scrollLeft = startScroll - dx;
      });

      function endDrag() {
        if (!down) return;
        down = false;
        if (rail.releasePointerCapture && pid !== null) {
          try { rail.releasePointerCapture(pid); } catch (err) {}
        }
        pid = null;
        /* Cleared on the NEXT frame, not here: the click lands after pointerup
           and the capture-phase handler below reads this flag to swallow it. */
        if (moved) requestAnimationFrame(function () { rail.classList.remove('is-dragging'); });
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);

      rail.addEventListener('click', function (e) {
        if (!moved) return;
        moved = false;
        e.preventDefault();
        e.stopImmediatePropagation();
      }, true);

      /* The bar answers a press too — pressing anywhere on it jumps there, and
         holding scrubs. Mapped from the pointer's position across the track,
         minus half a thumb so the thumb centres under the finger. */
      if (bar) {
        var barDown = false;
        function scrub(e) {
          var r = bar.getBoundingClientRect();
          var total = rail.scrollWidth, visible = rail.clientWidth;
          var thumbW = r.width * (visible / total);
          var travel = r.width - thumbW;
          if (travel <= 0) return;
          var x = Math.min(Math.max(e.clientX - r.left - thumbW / 2, 0), travel);
          rail.scrollLeft = (x / travel) * (total - visible);
        }
        bar.addEventListener('pointerdown', function (e) {
          barDown = true;
          if (bar.setPointerCapture) { try { bar.setPointerCapture(e.pointerId); } catch (err) {} }
          scrub(e);
          e.preventDefault();
        });
        bar.addEventListener('pointermove', function (e) { if (barDown) { scrub(e); e.preventDefault(); } });
        bar.addEventListener('pointerup', function () { barDown = false; });
        bar.addEventListener('pointercancel', function () { barDown = false; });
      }

      /* The dialog can be resized or rotated while closed, and the row's own
         width changes with it. */
      if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(rail);
      paint();
    }

    function closePicker() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    cards.forEach(function (card, i) {
      var btn = card.querySelector('[data-rac-offerpick]');
      if (btn) btn.addEventListener('click', function () { active = i; render(); });
    });

    /* THE SINGLE OPTION ADDS TO CART, it does not only select.

       "Pilates Mat Only $29.95" is the opt-out from the bundle ladder — there
       is nothing left to configure once it is picked, so making the buyer
       select it and then find the CTA is a step that buys nothing. Pressing it
       is the purchase decision.

       render() FIRST, and that ordering is load-bearing: syncForm() strips the
       `items[][id]` inputs that a previously selected bundle left on the form
       whenever `active < 0`. Adding before it ran would post the single
       product AND whatever accessories were in the bundle's slots.

       Runs the SHARED add — `root.__racAdd`, published by the add-to-cart
       block further up this file — and passes this button as the control to
       show the spinner on. It used to synthesise a click on the main CTA,
       which added correctly but animated a button the shopper was not looking
       at while the one under their finger sat inert.

       THE DISABLED CHECK IS THE DEDUPE, not a nicety. reformly-acc.js is
       linked twice on this template — once from reformly-acc-hero and once
       from reformly-acc-reviews — and a repeated <script src> is fetched once
       but EXECUTES once per element, so every listener in this file is bound
       twice. The CTA's own handler survives that because it calls
       stopImmediatePropagation and dedupes within a single event; two bound
       copies of THIS handler are two separate calls and would post two adds.
       __racAdd disables the pressed button synchronously, before its fetch, so
       the second call stops here. The check also covers a press landing
       mid-add, so it still reads correctly if the duplicate <script> goes. */
    if (singleBtn) {
      singleBtn.addEventListener('click', function () {
        /* HOLD THE BUTTON STILL ACROSS THE RE-RENDER.

           render() sets `hidden` on the selected card's slot list, and that
           list is ABOVE this button — three accessory rows' worth of height
           disappearing from the flow pulls everything below it up by ~200px,
           so the page appeared to scroll on press. Nothing was scrolling: the
           document got shorter under a fixed scrollTop.

           Measured against this button's own rect rather than saved as a
           scrollY, because the shift is a layout change and not a scroll — the
           correction is however far the button itself moved. scrollBy with
           'instant' so the fix lands in the same frame as the collapse and
           reads as the row simply closing. */
        var before = singleBtn.getBoundingClientRect().top;
        active = -1;
        render();
        var delta = singleBtn.getBoundingClientRect().top - before;
        if (delta) window.scrollBy({ top: delta, behavior: 'instant' });

        if (singleBtn.disabled) return;
        if (typeof root.__racAdd === 'function') root.__racAdd(singleBtn);
      });
    }

    if (dialog) {
      var closeBtn = dialog.querySelector('[data-rac-picker-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePicker);

      /* The dialog element IS the backdrop, so a click on it landed outside
         the card. */
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closePicker();
      });

      rows.forEach(function (b) {
        b.addEventListener('click', function () {
          if (active < 0 || editing < 0) return closePicker();
          var cur = chosen[active][editing];
          var same = !!cur && cur.variant === b.dataset.variant;
          /* Pressing the row that is already in this slot CLEARS it — which
             is what the purple X on a selected row means. */
          chosen[active][editing] = same ? null : {
            variant: b.dataset.variant,
            name: b.dataset.name,
            colour: b.dataset.colour,
            image: b.dataset.image,
            price: parseInt(b.dataset.price, 10) || 0,
            compare: parseInt(b.dataset.compare, 10) || parseInt(b.dataset.price, 10) || 0
          };
          closePicker();
          render();
        });
      });

      /* "" is All, "__best" is the bestseller flag, anything else is a
         block id. Presentational only — rows are hidden, never re-fetched. */
      var chips = [].slice.call(dialog.querySelectorAll('[data-rac-filter]'));
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var want = chip.dataset.racFilter || '';
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-on', on);
            c.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          rows.forEach(function (b) {
            b.hidden = want === '' ? false
              : want === '__best' ? b.dataset.best !== 'true'
              : b.dataset.group !== want;
          });
          if (list) list.scrollTop = 0;
        });
      });
    }

    /* Exposed so the option selector can repaint the locked first row when
       the colour changes — see initOptions. */
    wrap.__racRender = function () {
      main.colour = wrap.dataset.mainColour || '';
      main.image = wrap.dataset.mainImage || '';
      main.price = parseInt(wrap.dataset.mainPrice, 10) || main.price;
      main.compare = parseInt(wrap.dataset.mainCompare, 10) || main.price;
      render();
    };

    /* Land on the first offer, which is what the export does — the page
       should open on a bundle, not on the single item. */
    active = 0;
    render();
  }

  function boot() {
    document.querySelectorAll('[data-rac]').forEach(initOptions);
    document.querySelectorAll('[data-rac]').forEach(initOffers);
    document.querySelectorAll('[data-rac]').forEach(init);
    document.querySelectorAll('[data-racr]').forEach(initReviews);
    document.querySelectorAll('[data-racl]').forEach(initRail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
